export function needsPolicyAcceptance(user, currentVersion) {
  if (!user || !currentVersion) return false;
  return user.policyAcceptance?.version !== currentVersion;
}
